import { useQuery } from '@tanstack/react-query'
import type { MeProviderResponse } from 'shared'
import { apiGet } from '../lib/api'
import { useSession } from '../lib/auth-client'

export const providerMeKey = ['provider', 'me'] as const

// the caller's own provider profile, or { provider: null } if they have none.
// only runs when authenticated so logged-out visitors don't hit the 401 path.
export function useProviderProfile() {
  const { data: session } = useSession()

  return useQuery({
    queryKey: providerMeKey,
    queryFn: ({ signal }) => apiGet<MeProviderResponse>('/providers/me', signal),
    enabled: !!session?.user,
  })
}
